
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Brain, Menu, X, User, Home } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import UserProfileDropdown from "@/components/navigation/UserProfileDropdown";
import ThemeToggle from "@/components/common/ThemeToggle";
import { LanguageSelector } from "@/components/LanguageSelector";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, profile } = useAuth();
  const navigate = useNavigate();

  const closeMenu = () => setIsMenuOpen(false);

  const handleLoginClick = () => {
    navigate("/login");
    closeMenu();
  };

  const handleRegisterClick = () => {
    navigate("/register");
    closeMenu();
  };

  return (
    <nav className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <Brain className="h-8 w-8 text-primary" />
            <span className="text-xl font-bold text-foreground">PsyOnline</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
            >
              <Home className="h-4 w-4" />
              Início
            </Link>
            <Link 
              to="/psychologists" 
              className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
            >
              <User className="h-4 w-4" />
              Psicólogos
            </Link>

            {/* Language Selector - Desktop */}
            <LanguageSelector />

            {/* Theme Toggle - Desktop */}
            <ThemeToggle />

            {isAuthenticated ? (
              <UserProfileDropdown />
            ) : (
              <div className="flex items-center space-x-3">
                <Button variant="ghost" size="sm" onClick={handleLoginClick}>
                  Entrar
                </Button>
                <Button size="sm" onClick={handleRegisterClick}>
                  Cadastrar
                </Button>
              </div>
            )}
          </div>

          {/* Mobile menu button and controls */}
          <div className="md:hidden flex items-center gap-2">
            <LanguageSelector />
            <ThemeToggle />
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-border">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-background">
              <Link
                to="/"
                onClick={closeMenu}
                className="block px-3 py-2 text-muted-foreground hover:text-foreground transition-colors"
              >
                Início
              </Link>
              <Link
                to="/psychologists"
                onClick={closeMenu}
                className="block px-3 py-2 text-muted-foreground hover:text-foreground transition-colors"
              >
                Psicólogos
              </Link>

              {isAuthenticated ? (
                <div className="border-t border-border pt-3 mt-3">
                  <UserProfileDropdown />
                </div>
              ) : (
                <div className="border-t border-border pt-3 mt-3 space-y-2">
                  <Button variant="ghost" size="sm" className="w-full" onClick={handleLoginClick}>
                    Entrar
                  </Button>
                  <Button size="sm" className="w-full" onClick={handleRegisterClick}>
                    Cadastrar
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
